let imchargelist3 = [
  { title: "Shipping Line", label: "chship", in: true, out: false },

  { title: "Shipping Line", label: "chship", in: false, out: true },
  { title: "DTHC", label: "chdthc", in: false, out: true },
];
export default imchargelist3;
